import { useSelector } from 'react-redux';
import { params, childRoutePaths, routePaths } from 'utils/routeHelper';

export const useRouteParams = () => {
    const pathname = useSelector(state => state.router.location.pathname);

    return params([...childRoutePaths, ...routePaths], pathname)?.params || {};
};
